import { deschideSetariCookie } from '@/core/consent/cookie-consent';

/**
 * „Setări cookie-uri" pe paginile publice — acordul trebuie sa poata fi retras la fel de usor cum
 * a fost dat, si inainte de login nu exista meniul din `NavUser`.
 *
 * Sub `md` documentul curge (`main.css`, blocul `max-width: 767px`), deci linkul sta static la
 * finalul paginii si nu poate acoperi un buton. Pe desktop `#root` taie overflow-ul, deci un link
 * static ar fi sub linia de taiere: acolo e fix, dreapta-jos, SUB barele fixe `z-10` ale paginilor
 * (fara z-index propriu), ca sa nu concureze cu un buton de trimitere.
 */
export function LinkSetariCookie() {
    return (
        <div className="flex justify-center bg-white px-4 py-3 md:fixed md:bottom-2 md:right-2 md:rounded-md md:px-2 md:py-1">
            <button
                type="button"
                onClick={deschideSetariCookie}
                className="touch-target-link text-smaller text-gray-600 underline"
            >
                Setări cookie-uri
            </button>
        </div>
    );
}
